import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';
import { GetVisitSummaryApiRequest } from '../../../external/VisitApi';
import { HndlItmMngMst } from '../../../external/HndlItmMngApi';

/** 来店予約：店舗情報 */
// eslint-disable-next-line
export interface VisitReservationStoreInfo extends HndlItmMngMst {}

/** 来店予約：サマリタブに表示する情報 */
export interface VisitReservationSummaryInfo {
  /** 予約数WEB表示リスト */
  onlineReservationlist?: summaryItemData[];
  /** 予約数クルー表示リスト */
  crewReservationlist?: summaryItemData[];
  /** 事前準備架電表示リスト */
  befCalllist?: summaryItemData[];
  /** LINEステータス */
  lineContactList?: summaryItemData[];
  /** 事前準備クルーヒアリング表示リスト */
  advancePreparationCrewHearinglist?: summaryItemData[];
  /** 事前準備照会表示リスト */
  advancePreparationInquirylist?: summaryItemData[];
  /** 時間帯別レポートクルー表示リスト */
  reportCrewList?: number[];
  /** 時間帯別レポートWEB表示リスト */
  reportWebList?: number[];
  /** 件数 */
  count: number;
}

/** 来店予約：サマリ表示項目データ */
export interface summaryItemData {
  label: string;
  count: number;
}

/** 来店予約：予約一覧タブに表示する情報 */
export interface VisitReservationListInfo {
  /** リスト情報 */
  list: VisitReservationInfo[];
  /** 件数 */
  count: number;
}

/** 来店予約：予約一覧タブに表示する情報 */
export interface VisitReservationInfo {
  /** 予約時刻 */
  sendDatetime: string;
  /** 案内番号 */
  code: string;
  /** 業務 */
  business: string;
  /** 担当者 */
  staff: string;
  /** ルート */
  route: string;
  /** 動画 */
  movie: string;
  /** 照会 */
  inquiry: string;
  /** 架電 */
  call: string;
  /** ヒアリング */
  hearing: string;
  /** ヒアリング(WEB) */
  hearingWeb: string;

  hearingId: string | null;
  firstInsDate: string | null;
  /** LINEステータス */
  lineContactFlg?: string;
  /** 「ヒアリングQR」ステータス */
  hearingQr?: string;
}

export interface VisitReservationSummaryAndListInfo {
  /** サマリ表示情報 */
  summaryInfo: VisitReservationSummaryInfo;
  /** 予約一覧表示情報 */
  listInfo: VisitReservationListInfo;
}

export interface VisitReservationInfoState extends VisitReservationSummaryAndListInfo {
  /** 店舗リスト */
  storeList: VisitReservationStoreInfo[];
  /** 来店予約サマリ・予約一覧検索条件 */
  getVisitSummaryApiRequest: GetVisitSummaryApiRequest;
}

export const initialVisitReservationInfoState: VisitReservationInfoState = {
  storeList: [],
  getVisitSummaryApiRequest: {
    visitSummaryInfoList: [],
  },
  summaryInfo: { count: 0 },
  listInfo: { list: [], count: 0 },
};

export const VisitReservationInfoReducer = reducerWithInitialState(initialVisitReservationInfoState)
  .case(actions.visitReservationInfo.init, () => {
    return initialVisitReservationInfoState;
  })
  .case(actions.visitReservationInfo.updateVisitReservationInfo, (_, payload: VisitReservationInfoState) => {
    return {
      ...payload,
    };
  })
  .case(actions.visitReservationInfo.updateStoreList, (state: VisitReservationInfoState, payload: Array<VisitReservationStoreInfo>) => {
    return {
      ...state,
      storeList: payload,
    };
  })
  .case(actions.visitReservationInfo.updateGetSummaryApiRequest, (state: VisitReservationInfoState, payload: GetVisitSummaryApiRequest) => {
    return {
      ...state,
      getVisitSummaryApiRequest: payload,
    };
  })
  .case(actions.visitReservationInfo.updateSummaryInfo, (state: VisitReservationInfoState, payload: VisitReservationSummaryInfo) => {
    return {
      ...state,
      summaryInfo: payload,
    };
  })
  .case(actions.visitReservationInfo.updateListInfo, (state: VisitReservationInfoState, payload: VisitReservationListInfo) => {
    return {
      ...state,
      listInfo: payload,
    };
  });
